import { render, staticRenderFns } from "./metric-filter.vue?vue&type=template&id=b80e7642"
import script from "./metric-filter.vue?vue&type=script&lang=js"
export * from "./metric-filter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports